import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from "react-router-dom";

import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import ProductPage from "./pages/ProductsPage";
import CategoriesPage from "./pages/CategoriesPage";
import SubcategoriesPage from "./pages/SubcategoriesPage";
import InquiriesPage from "./pages/InquiriesPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import Header from "./layout/Header";

import { getCurrentUser, logout as authLogout } from "./services/authService";
import GalleryAdminPage from "./pages/GalleryAdminPage";
import SiteSettingsAdmin from "./pages/SiteSettingsAdmin";

/** Обгортка щоб мати навігацію в onLogout */
function AppShell() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [role, setRole] = useState(null);
  const [bootLoading, setBootLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const user = await getCurrentUser();
        if (!mounted) return;
        setLoggedIn(true);
        setRole(user?.role ?? null);
      } catch {
        if (!mounted) return;
        setLoggedIn(false);
        setRole(null);
      } finally {
        if (mounted) setBootLoading(false);
      }
    })();

    const onStorage = (e) => {
      if (e.key === "token") {
        if (e.newValue == null) {
          setLoggedIn(false);
          setRole(null);
          navigate("/login", { replace: true });
        } else {
          getCurrentUser()
            .then((user) => {
              setLoggedIn(true);
              setRole(user?.role ?? null);
            })
            .catch(() => {
              setLoggedIn(false);
              setRole(null);
            });
        }
      }
    };
    window.addEventListener("storage", onStorage);

    return () => {
      mounted = false;
      window.removeEventListener("storage", onStorage);
    };
  }, [navigate]);

  const handleLoginSuccess = async () => {
    try {
      const user = await getCurrentUser();
      setLoggedIn(true);
      setRole(user?.role ?? null);
      navigate("/dashboard", { replace: true });
    } catch {
      setLoggedIn(false);
      setRole(null);
    }
  };

  const handleLogout = () => {
    authLogout();
    setLoggedIn(false);
    setRole(null);
    navigate("/login", { replace: true });
  };

  if (bootLoading) {
    return <div style={{ padding: 24 }}>Завантаження...</div>;
  }

  return (
    <>
      {loggedIn && <Header onLogout={handleLogout} />}

      <Routes>
        {/* Публічні */}
        <Route path="/login" element={<LoginPage onLogin={handleLoginSuccess} />} />

        {/* Приватні */}
        {loggedIn ? (
          <>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/products" element={<ProductPage />} />
            <Route path="/product/:slug" element={<ProductPage />} />  
            <Route path="/product-id/:id" element={<ProductPage />} />
            <Route path="/categories" element={<CategoriesPage />} />
            <Route path="/subcategories" element={<SubcategoriesPage />} />
            <Route path="/inquiries" element={<InquiriesPage />} />
            <Route path="/gallery" element={<GalleryAdminPage />} />
            <Route path="/settings" element={<SiteSettingsAdmin />} />
            {role === "superadmin" && <Route path="/admins" element={<AdminUsersPage />} />}

            {/* default */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </>
        ) : (
          <Route path="*" element={<Navigate to="/login" replace />} />
        )}
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <AppShell />
    </Router>
  );
}


// import React, { useEffect, useState } from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from "react-router-dom";

// import LoginPage from "./pages/LoginPage";
// import Dashboard from "./pages/Dashboard";
// import ProductPage from "./pages/ProductsPage";
// import CategoriesPage from "./pages/CategoriesPage";
// import SubcategoriesPage from "./pages/SubcategoriesPage";
// import InquiriesPage from "./pages/InquiriesPage";
// import AdminUsersPage from "./pages/AdminUsersPage";
// import Header from "./layout/Header";

// import { getCurrentUser, logout as authLogout } from "./services/authService";
// import GalleryAdminPage from "./pages/GalleryAdminPage";
// import SiteSettingsAdmin from "./pages/SiteSettingsAdmin";

// /** Обгортка щоб мати навігацію в onLogout */
// function AppShell() {
//   const [loggedIn, setLoggedIn] = useState(false);
//   const [role, setRole] = useState(null);
//   const [bootLoading, setBootLoading] = useState(true);
//   const navigate = useNavigate();

//   // 1) Перевіряємо токен при старті/перезавантаженні
//   useEffect(() => {
//     let mounted = true;
//     (async () => {
//       try {
//         const user = await getCurrentUser(); // кине помилку, якщо токена нема/невірний
//         if (!mounted) return;
//         setLoggedIn(true);
//         setRole(user?.role ?? null);
//       } catch {
//         if (!mounted) return;
//         setLoggedIn(false);
//         setRole(null);
//       } finally {
//         if (mounted) setBootLoading(false);
//       }
//     })();

//     // 2) Слухаємо зміни токена з інших вкладок
//     const onStorage = (e) => {
//       if (e.key === "token") {
//         // якщо видалили токен в іншій вкладці
//         if (e.newValue == null) {
//           setLoggedIn(false);
//           setRole(null);
//           navigate("/login", { replace: true });
//         } else {
//           // якщо зʼявився токен — валідуємо його
//           getCurrentUser()
//             .then((user) => {
//               setLoggedIn(true);
//               setRole(user?.role ?? null);
//             })
//             .catch(() => {
//               setLoggedIn(false);
//               setRole(null);
//             });
//         }
//       }
//     };
//     window.addEventListener("storage", onStorage);

//     return () => {
//       mounted = false;
//       window.removeEventListener("storage", onStorage);
//     };
//   }, [navigate]);

//   const handleLoginSuccess = async () => {
//     // після успішного логіну перевіряємо /me і переходимо на дашборд
//     try {
//       const user = await getCurrentUser();
//       setLoggedIn(true);
//       setRole(user?.role ?? null);
//       navigate("/dashboard", { replace: true });
//     } catch {
//       setLoggedIn(false);
//       setRole(null);
//     }
//   };

//   const handleLogout = () => {
//     authLogout();
//     setLoggedIn(false);
//     setRole(null);
//     navigate("/login", { replace: true });
//   };

//   if (bootLoading) {
//     return <div style={{ padding: 24 }}>Завантаження...</div>;
//   }

//   return (
//     <>
//       {loggedIn && <Header onLogout={handleLogout} />}

//       <Routes>
//         {/* Публічні */}
//         <Route path="/login" element={<LoginPage onLogin={handleLoginSuccess} />} />

//         {/* Приватні */}
//         {loggedIn ? (
//           <>
//             <Route path="/dashboard" element={<Dashboard />} />
//             <Route path="/products" element={<ProductPage />} />
//             // приклад
//             <Route path="/product/:slug" element={<ProductPage />} />  
//             <Route path="/product-id/:id" element={<ProductPage />} />

//             <Route path="/categories" element={<CategoriesPage />} />
//             <Route path="/subcategories" element={<SubcategoriesPage />} />
//             <Route path="/inquiries" element={<InquiriesPage />} />
//             <Route path="/gallery" element={<GalleryAdminPage />} />
//             <Route path="/settings" element={<SiteSettingsAdmin/>} />
//             {role === "superadmin" && <Route path="/admins" element={<AdminUsersPage />} />}

//             {/* default */}
//             <Route path="*" element={<Navigate to="/dashboard" replace />} />
//           </>
//         ) : (
//           <Route path="*" element={<Navigate to="/login" replace />} />
//         )}
//       </Routes>

//     </>
//   );
// }

// export default function App() {
//   return (
//     <Router>
//       <AppShell />
//     </Router>
//   );
// }

